import { logToDatadog } from "@brexhq/next/src/utils/datadog/log";
import { ExternalScripts } from "@brexhq/next/types/externalScripts";
import { isDev } from "@brexhq/shared/utils/env/isDevEnv";

export const logScriptLoadingError = (id: string, e?: any) => {
  logToDatadog("error", `Failed to load script ${id}`, e);
};

export const verifyScriptsLoaded = () => {
  if (isDev) return;

  // Filter can be removed once Glance is on production
  const externalScriptIds = Object.values(ExternalScripts).filter(
    (id) => id !== ExternalScripts.GLANCE_COBROWSE,
  );

  externalScriptIds.forEach((id) => {
    if (!document.getElementById(id)) {
      logScriptLoadingError(id);
    }
  });
};
